import { Axios, AxiosResponse } from 'axios'
import axiosInstance from '../../config/axios'
import { IAdditionalFiles } from '../../store/materials/types'
import materialUrls from '../../utils/urls/materialUrls'

const postAdditionalMaterial = (data: FormData): Promise<AxiosResponse> =>
  axiosInstance.post(materialUrls.getMaterialUrls(), data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

const getReportAdditionalMaterial = (
  reportId: number,
): Promise<AxiosResponse<IAdditionalFiles[]>> =>
  axiosInstance.get(materialUrls.getReportMaterialsUrl(reportId))

const patchAdditionalMaterial = (materialId: number, data: any): Promise<AxiosResponse> =>
  axiosInstance.patch(materialUrls.getFileIdUrl(materialId), data)

const deleteAdditionalMaterial = (materialId: number): Promise<AxiosResponse> =>
  axiosInstance.delete(materialUrls.getFileIdUrl(materialId))

const filterFiles = (reportId: number, filter: any): Promise<AxiosResponse> =>
  axiosInstance.get(materialUrls.getFilesUrl(), { params: { report: reportId, ...filter } })

const filterMaterials = (reportId: number, filter: any): Promise<AxiosResponse> =>
  axiosInstance.get(materialUrls.getReportMaterialsUrl(reportId), { params: { ...filter } })

const postFile = (file: FormData): Promise<AxiosResponse> =>
  axiosInstance.post(`${materialUrls?.getFilesUrl()}/`, file)

const getFileById = (fileId: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${materialUrls.getFilesUrl()}/${fileId}/`)

const patchFile = (fileId: number, data: any): Promise<AxiosResponse> =>
  axiosInstance.patch(materialUrls.getFileIdUrl(fileId), data)

const patchMaterialFiles = (materialId: number, fileId: number[]) =>
  axiosInstance.patch(`${materialUrls.getMaterialUrls()}${materialId}/`, { files: fileId })

const deleteFile = (fileId: number) =>
  axiosInstance?.delete(`${materialUrls?.getFileIdUrl(fileId)}`)

export default {
  postAdditionalMaterial,
  getReportAdditionalMaterial,
  patchAdditionalMaterial,
  deleteAdditionalMaterial,
  filterFiles,
  filterMaterials,
  postFile,
  getFileById,
  patchFile,
  patchMaterialFiles,
  deleteFile,
}
